var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E4E7DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6592 24.1897C10.684 24.3808 10.9616 24.3808 10.9858 24.1897C11.1755 22.7017 12.347 21.531 13.8343 21.3412C14.026 21.3164 14.026 21.0388 13.8343 21.0146C12.347 20.8249 11.1756 19.6534 10.9858 18.1661C10.9616 17.9744 10.684 17.9744 10.6592 18.1661C10.4694 19.6534 9.29869 20.8248 7.81073 21.0146C7.61895 21.0388 7.61895 21.3164 7.81073 21.3412C9.29866 21.531 10.4694 22.7017 10.6592 24.1897Z",
    fill: "#2D3245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.502 20.4825C17.5462 20.8278 18.0458 20.8278 18.0901 20.4825C18.489 17.3578 20.9492 14.8969 24.0746 14.4986C24.4199 14.4544 24.4199 13.9542 24.0746 13.9106C20.9492 13.5116 18.489 11.0507 18.0901 7.92605C18.0458 7.58073 17.5462 7.58073 17.502 7.92605C17.1037 11.0507 14.6428 13.5116 11.5175 13.9106C11.1728 13.9542 11.1728 14.4544 11.5175 14.4986C14.6428 14.8969 17.1037 17.3578 17.502 20.4825Z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.72801dffcd6b1d3084d32af41dbe1bef.svg";
export { ForwardRef as ReactComponent };